module.exports = __webpack_public_path__ + "img/kv_3_1.0232cea5.png";